import { apiClient } from './api'
import { ApiResponse } from './api'

export interface Asset {
  _id: string
  name: string
  description: string
  type: string
  createdAt: string
  createdBy: string | null
  updatedAt: string
  updatedBy: string | null
  deletedAt: string | null
  deletedBy: string | null
  __v: number
}

export interface CreateAssetRequest {
  name: string
  description: string
  type: string
}

export interface UpdateAssetRequest {
  name?: string
  description?: string
  type?: string
}


export interface GetAssetsParams {
  page?: number
  limit?: number
  search?: string
}

class AssetsApiService {
  private baseEndpoint = '/projects-service/api/v1/assets'

  async getAssets(_params?: GetAssetsParams): Promise<ApiResponse<Asset[]>> {
    try {
      // Note: API doesn't support query parameters, so we fetch all assets
      // and handle pagination/search on the client side
      const response = await apiClient.get<Asset[]>(this.baseEndpoint, undefined, 'PROJECTS')
      return response
    } catch (error) {
      console.error('Failed to fetch assets:', error)
      throw error
    }
  }

  async getAssetById(assetId: string): Promise<ApiResponse<Asset>> {
    try {
      const response = await apiClient.get<Asset>(`${this.baseEndpoint}/${assetId}`, undefined, 'PROJECTS')
      return response
    } catch (error) {
      console.error('Failed to fetch asset:', error)
      throw error
    }
  }

  async createAsset(assetData: CreateAssetRequest): Promise<ApiResponse<Asset>> {
    try {
      const response = await apiClient.post<Asset>(this.baseEndpoint, assetData, undefined, 'PROJECTS')
      return response
    } catch (error) {
      console.error('Failed to create asset:', error)
      throw error
    }
  }

  async updateAsset(assetId: string, assetData: UpdateAssetRequest): Promise<ApiResponse<Asset>> {
    try {
      const response = await apiClient.put<Asset>(`${this.baseEndpoint}/${assetId}`, assetData, undefined, 'PROJECTS')
      return response
    } catch (error) {
      console.error('Failed to update asset:', error)
      throw error
    }
  }

  async deleteAsset(assetId: string): Promise<ApiResponse<void>> {
    try {
      const response = await apiClient.delete<void>(`${this.baseEndpoint}/${assetId}`, undefined, 'PROJECTS')
      return response
    } catch (error) {
      console.error('Failed to delete asset:', error)
      throw error
    }
  }
}

export const assetsApi = new AssetsApiService()
